enum KeyType {
    MOVE = "MOVE",
    EMOTE = "EMOTE",
    NONE = "NONE"
}

export default KeyType;
